@if (sentTo(); as email) {
<app-auth-shell title="Verifique seu e-mail" icon="fas fa-envelope-open-text">
  <p class="auth-login__subtitle">
    Se houver uma conta para <strong>{{ email }}</strong>, você receberá as instruções para redefinir a senha em instantes. Confira também a caixa de spam.
  </p>
  <div class="auth-login__actions">
    <a class="auth-btn" [routerLink]="['/signin']">Voltar para o login</a>
    <p class="auth-login__note">
      Não recebeu o e-mail?
      <button type="button" class="auth-link" (click)="sendResetLink()" [disabled]="remainingSeconds() > 0">
        @if (remainingSeconds() > 0) { Reenviar em {{ remainingSeconds() }}s } @else { Reenviar }
      </button>
    </p>
    <p class="auth-login__note">
      <button type="button" class="auth-link" (click)="changeEmail()">Usar outro e-mail</button>
    </p>
  </div>
</app-auth-shell>
} @else {
<app-auth-shell title="Esqueceu a senha?" subtitle="Informe seu e-mail e enviaremos as instruções para redefinir a senha.">
  <form class="auth-login__form" role="form" [formGroup]="formForgot" (ngSubmit)="sendResetLink()" novalidate>
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formForgot.get('email')?.dirty) { @if (formForgot.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formForgot.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formForgot.valid">Enviar instruções</button>
  </form>
  <p class="auth-login__signup" authShellFooter>
    Lembrou a senha?
    <a [routerLink]="['/signin']">Voltar para o login</a>
  </p>
</app-auth-shell>
}
